import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginMtfHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import NoDataContainer from "../../../../generic/noDataContainer";

export interface IMarginMtfTableDskProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginMtfTableDsk: React.FC<IMarginMtfTableDskProps> = props => {
	return (
		<div className="mrgn_mtf_tbl table">
			<ul className="hdr_row">
				<li className="tr">
					<div className="td Name">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="Name"
								onSort={props.sortProps.onSort}
								colName={marginMtfHeading.name}
							/>
						</span>
					</div>
					<div className="td NSESymbol">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="NSESymbol"
								onSort={props.sortProps.onSort}
								colName={marginMtfHeading.nseSymbol}
							/>
						</span>
					</div>
					<div className="td BSECode">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="BSECode"
								onSort={props.sortProps.onSort}
								colName={marginMtfHeading.bseCode}
							/>
						</span>
					</div>
					<div className="td ISIN">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="ISIN"
								onSort={props.sortProps.onSort}
								colName={marginMtfHeading.isin}
							/>
						</span>
					</div>
					<div className="td Haircut right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="Haircut"
								onSort={props.sortProps.onSort}
								colName={marginMtfHeading.Haircut}
							/>
						</span>
					</div>
				</li>
			</ul>

			{props.tableData.length ? (
				<ul className="mrgn_scrl_cont data_rows">
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<React.Fragment key={index}>
							<li className="tr">
								<div className="td Name robotoM">
									<span dangerouslySetInnerHTML={{ __html: row.Name }}></span>
								</div>
								<div className="td NSESymbol">{row.NSESymbol}</div>
								<div className="td BSECode">{row.BSECode}</div>
								<div className="td ISIN">{row.ISIN}</div>
								<div className="td Haircut right">{toINR(row.Haircut)}</div>
							</li>
						</React.Fragment>
					))}
				</ul>
			) : (
				<NoDataContainer txtHeading="No results found" />
			)}
		</div>
	);
};

export default MarginMtfTableDsk;
